import { formateDate } from '@/utils/utils.js';
export default {
  data() {
    return {};
  },
  props: ['type', 'name'],
  methods: {
    // 判断操作系统
    detectOS() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return "0";
      }
      if (/android/i.test(userAgent)) {
        return "0";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "1";
      }
      if (/HarmonyOS/.test(userAgent)) {
        return "2";
      }
      // 其他可能的操作系统判断...
      return "0";
    },
    // 湘易办埋点
    async xybMaiDian() {
      const appInfo = this.detectOS();
      const curr_time = formateDate(new Date());
      let that = this;
      const locationData = await this.$xybAgent.getLocationInfo();
      // 衡阳博物馆增加湘易办的埋点
      this.$xybAgent.track('pageview', {
        code: this.type == 'audio' ? 'XYB_SBWG_430400_ZZYYJJ' : 'XYB_SBWG_430400_WWZS',
        //事项编码
        name: this.type == 'audio' ? '自助语音讲解' : '3D文物展示',
        //事项名称
        source: 'app',
        //访问渠道
        page_source: 'click',
        // 访问量来源
        aff_city_code: '430400',
        // 所属省、市级编码
        aff_city_name: '衡阳市',
        // 所属省、市级名称
        unit_code: '4304',
        // 所属省级单位编码
        unit_name: '衡阳市',
        //所属单位简称
        category: '3',
        //事项分类 1、查询类 2、办理类 3、公式类 4、其他分类
        is_finish: '2',
        //业务办结  
        user_id: '',
        //用户ID
        location: locationData.location,
        //定位
        curr_time: curr_time,
        //用户触发埋点事件的时间yyyy-MM-dd HH:mm:ss
        device_type: appInfo,
        //设备类型 安卓：0；ios：1；鸿蒙：2
        miniAppCode: 'YDYY_SBWG_BWG',
        //应用编码
        $url_domain: `${location.origin}${location.pathname}/#/${that.name}` //页面URL(去参的页面URL)，非事项必传
      });
    }
  },
  created() {},
  computed: {},
  mounted() {
    // 衡阳博物馆湘易办埋点
    // if (this.$route.query.fid != 138362) return
    // this.$xybAgent.init('production')
    // this.xybMaiDian()
  }
};